import RequestCriterion from "./RequestCriterion";

export default interface RequestCriterionData {
  isConsentAccepted?: boolean;
  comment: string;
  criteria: RequestCriterion[];
}

export const requestCriterionDataInitial: RequestCriterionData = {
  isConsentAccepted: undefined,
  comment: "",
  criteria: [],
};
